import Vue from 'vue'
import VueRouter from 'vue-router'
import { routerConfig } from './config.js'
import store from '@/store/index.js'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// const router = new VueRouter({
// 	routes: routerConfig
// })

// router.beforeEach((to, from, next) => {
// 	window.scrollTo(0, 0);
// 	next();
// });

// export default router


//ssr修改-zl
export default function createRouter() {
	let router = new VueRouter({
	  mode: "history",  // 一定要history 
	  base: process.env.BASE_URL,
	  routes:routerConfig,
	  scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	  }
	});

	router.beforeEach((to, from, next) => {
		// window.scrollTo(0, 0);

		// if (to.meta.title2) {
		// 	document.title = to.meta.title2;
		// }
		next();
	
	});

	return router;
}
